import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Globals } from "../../globals";
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';




@Injectable()
export class AdvancedAnalyticsServices {
    //si es basic, 7 dias
    //si es pro, 30 dias
    public date1 = moment().subtract(1, 'month').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    public date2 = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    public date = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD');

    public limit_date1 = '';
    public limit_date2 = '';

    public config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };


    constructor(
        public globals: Globals,
        public translate: TranslateService) {
    }

    limitDays() {
        //Free - Pro - Basic
        if (this.globals.checkLimitsByLicense('analytics', 'limit_days') != -1) {
            this.limit_date1 = moment().subtract(this.globals.checkLimitsByLicense('analytics', 'limit_days'), 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
            this.limit_date2 = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
            this.date1 = this.limit_date1;
            this.date2 = this.limit_date2;
        }
    }

    resetLimitDays() {
        this.limit_date1 = '';
        this.limit_date2 = '';
    }
}



// WEBPACK FOOTER //
// ./src/pages/analytics/advanced-analytics-services.ts